import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import AndroidDownloadView from "../views/AndroidDownloadView";
import AppleDownloadView from "../views/AppleDownloadView";
import TutorialsView from "../views/TutorialsView";
import CredencialPolicial from "@/views/CredendialPolicialView.vue"
import AdminServicios from "@/views/AdminServiciosView.vue"
import MapaView from "../views/MapaView.vue";
import GraficosView from "../views/GraficosView.vue";
import DemoView from "../views/DemoView.vue";
import BusquedaAntecedentesView from "../views/BusquedaAntecedentesView.vue";
import PrediccionesIAView from "../views/PrediccionesIAView.vue";
import VehiculosSecuestroView from "../views/VehiculosSecuestroView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },

  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginPage.vue"),
  },
  {
    path: "/android",
    name: "androidDownload",
    component: AndroidDownloadView,
  },
  {
    path: "/apple",
    name: "appleDownload",
    component: AppleDownloadView,
  },
  {
    path: "/credencial",
    name: "credencial",
    component: CredencialPolicial,
  },
  {
    path: "/tutoriales",
    name: "tutorials",
    component: TutorialsView,
  }, 
  {
    path: "/admin-servicios",
    name: "admin-servicios",
    component: AdminServicios,
  },
  {
    path: "/mapa",
    name: "mapa",
    component: MapaView,
  },
  {
    path: "/graficos",
    name: "graficos",
    component: GraficosView,
  },
  {
    path: "/demo",
    name: "demo",
    component: DemoView,
  },
  {
    path: "/busqueda-antecedentes",
    name: "busqueda-antecedentes",
    component: BusquedaAntecedentesView,
  },
  {
    path: "/predicciones-ia",
    name: "predicciones-ia",
    component: PrediccionesIAView,
  },
  {
    path: "/vehiculos-secuestro",
    name: "vehiculos-secuestro",
    component: VehiculosSecuestroView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
